import React from "react";
import styled from "styled-components";
import PrimaryButton from "../../buttons/PrimaryButton";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.section`
  margin-bottom: 60px;
`;

const Container = styled.div`
  max-width: 80vw;
  margin: auto;
  padding: 48px 0;
  background-color: #e8e8e8c9;

  @media (max-width: 950px) {
    max-width: 100%;
    margin: auto 20px;
    padding: 48px 0;
  }
`;

const Columns = styled.div`
  display: flex;
  align-items: center;
  max-width: 60vw;
  margin: auto;
  gap: 40px;

  @media (max-width: 950px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    max-width: 70vw;
    gap: 16px;
  }
`;

const Column = styled.div`
  flex: 1;
`;

const InfoList = styled.ul`
  padding-left: 0;       
  margin: 0;

  li {
    color: #000000c6;
    margin-bottom: 16px;
    font-size: ${fontSize.xxs};
    line-height: 1.4;
  }

  li:first-child {
    font-size: ${fontSize.s};
    color: #000;
    list-style: none;
    text-decoration: none;
  }
`;

const InputContainer = styled.div`
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 950px) {
    max-width: 100%;
  }
`;

const Title = styled.h3`
  font-weight: 400;
  font-size: ${fontSize.s};
  margin: 0;
`;

const SubTitle = styled.p`
  font-size: ${fontSize.xxs};
  line-height: 1.2rem;
  margin: 0;
`;

const Input = styled.input`
  width: 100%;
  max-width: 300px;
  border: none;
  border-bottom: 1px solid #000;
  background: transparent;
  caret-color: black;

  &::placeholder {
    color: black;
  }

  &:focus {
    outline: none;
  }
`;

function CheckCertificate() {
  return (
    <Wrapper>
      <Container>
        <Columns>
          <Column>
            <InputContainer>
              <Title>Verify ownership with your serial code</Title>
              <SubTitle>
                Your Peak Pashmina product, if authentic, is accompanied by a
                unique serial code, which, when entered, will generate an
                official certificate of authenticity in the name of the owner.
              </SubTitle>

              <Input placeholder="Enter serial code" />

              <PrimaryButton
                onClick={() => {}}
                title="Continue"
                width="min(100%, 50%)"
              />
            </InputContainer>
          </Column>

          <Column>
            <InfoList>
              <li>
                <a>Ensuring Authenticity with Peak Pashmina</a>
              </li>
              <li>
                Every Peak Pashmina product comes with a unique serial code,
                located either on the hang tag or inside the box.
              </li>
              <li>
                If the serial code is missing, simply log in to your account to
                view your purchase details and serial code.
              </li>
              <li>
                Purchasing from our official website guarantees the authenticity
                of your Peak Pashmina.
              </li>
              <li>
                For any questions or concerns, feel free to contact our customer
                service team — we're here to help!
              </li>
            </InfoList>
          </Column>
        </Columns>
      </Container>
    </Wrapper>
  );
}

export default CheckCertificate;
